import Link from "next/link";

const faqs = [
  {
    question: "What is SOP writer?",
    answer:
      "SOP writer is a software tool that uses artificial intelligence to assist with the creation of Statement of Purpose (SOP). A statement of purpose (SOP) is a written document that outlines an individual's goals, experiences, and qualifications. It is often required as part of a college or graduate school application and is used to help admissions committees understand an applicant's motivations and fit for the program. They are required in the application process for applying for abroad study. The AI-based SOP writer can help to streamline the SOP writing process.",
  },

  {
    question: "Is SOP writer suitable for all types of SOPs?",
    answer:
      "SOP writer can be used for a wide range of SOPs, but currently we are offering it for more or less study visa. That being said we understand that SOPs are needed in a wide range of scenarios that's why the next phase of this product focuses covering all the different domains in terms of SOPs.",
  },
  {
    question: "Is the output from SOP writer accurate?",
    answer:
      "AI generated SOP writers are generally close to perfection, but it is important to carefully review and edit any SOPs generated by this tool to ensure that they are accurate, complete, and meet your organization's specific needs and guidelines. As with any automated tool, it is always a good idea to double-check the output for accuracy and make any necessary corrections.",
  },
  {
    question: "Can this tool write SOPs from scratch?",
    answer:
      "With minimal users to input which would include just a few details about you and some necessary stuff content can be generated by this tool.",
  },

  // More questions...
];

export default function FAQs() {
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
        <div className="lg:grid lg:grid-cols-3 lg:gap-8">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900">
              Frequently asked questions
            </h2>
            <p className="mt-4 text-lg text-gray-500">
              Can&apos;t find the answer you&apos;re looking for? Reach out to
              our{" "}
              <Link
                href="#contact"
                className="font-medium text-primary-500 hover:text-primary-400"
              >
                customer support
              </Link>{" "}
              team.
            </p>
          </div>
          <div className="mt-12 lg:col-span-2 lg:mt-0">
            <dl className="space-y-12">
              {faqs.map((faq) => (
                <div key={faq.question}>
                  <dt className="text-lg font-medium leading-6 text-gray-900">
                    {faq.question}
                  </dt>
                  <dd className="mt-2 text-base text-gray-500">{faq.answer}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
